import React from "react";

import { useGetCurrentCompanyApplicationQuery, useGetUserExperienceFlagsQuery } from "EmployerApplication/api";
import { useDisabilityEnabled } from "EmployerApplication/hooks";
import { useSelector } from "react-redux";

import { TitleSmall } from "Cobalt/Header";
import { getCart } from "Common/CartService";
import { Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";
import { Tabs, Tab } from "Common/Tabs/Tabs";

import LifeCompactCard from "./LifeCompactCard";
import LongTermDisabilityCompactCard from "./LongTermDisabilityCompactCard";
import { useIsEligibleForLifePlans } from "./shoppingCartSection/LifePlanEligibility";
import ShortTermDisabilityCompactCard from "./ShortTermDisabilityCompactCard";

const AdditionalPlansSection = () => {
  const { data: { companyIDToken } = {} } = useGetCurrentCompanyApplicationQuery();
  const { data: userExperienceFlags } = useGetUserExperienceFlagsQuery({
    companyIDToken,
  });

  const hasAddedLifePlan = userExperienceFlags?.added_life_plan;

  const { longTermDisability: longTermDisabilityPlanInCart, shortTermDisability: shortTermDisabilityPlanInCart } = useSelector(getCart);
  const lifePlanEligible = useIsEligibleForLifePlans();
  const { enabled: inDisabilityABTest } = useDisabilityEnabled();

  const renderTabs = () => {
    const additionalPlanCards = [];
    if (lifePlanEligible || hasAddedLifePlan) {
      additionalPlanCards.push(
        <Tab label="life" tabName="Life">
          <Div mt={4}>
            <LifeCompactCard />
          </Div>
        </Tab>,
      );
    }
    if (inDisabilityABTest || shortTermDisabilityPlanInCart) {
      additionalPlanCards.push(
        <Tab label="std" tabName="Short Term Disability">
          <Div mt={4}>
            <ShortTermDisabilityCompactCard />
          </Div>
        </Tab>,
      );
    }
    if (inDisabilityABTest || longTermDisabilityPlanInCart) {
      additionalPlanCards.push(
        <Tab label="ltd" tabName="Long Term Disability">
          <Div mt={4}>
            <LongTermDisabilityCompactCard />
          </Div>
        </Tab>,
      );
    }
    return additionalPlanCards.length > 0 && <Tabs scrollableTabNames>{additionalPlanCards.map((card) => card)}</Tabs>;
  };

  const renderCards = () => (
    <Row mt={4}>
      {(lifePlanEligible || hasAddedLifePlan) && (
        <Col md={4}>
          <LifeCompactCard />
        </Col>
      )}

      {(inDisabilityABTest || shortTermDisabilityPlanInCart) && (
        <Col md={4}>
          <ShortTermDisabilityCompactCard />
        </Col>
      )}

      {(inDisabilityABTest || longTermDisabilityPlanInCart) && (
        <Col md={4}>
          <LongTermDisabilityCompactCard />
        </Col>
      )}
    </Row>
  );

  return (
    <>
      <Row>
        <Col>
          <TitleSmall mt={0} mb={0}>
            Additional Plans
          </TitleSmall>
        </Col>
      </Row>
      <SizeSwitch xs={renderTabs()} md={renderCards()} />
    </>
  );
};

export default AdditionalPlansSection;
